import mainSnap from "../assets/small-logo.png";
export const DynamicImage = ({imageName}) => {
    try{
        // const imagePath = new URL(`../assets/flag/${imageName}.png`, import.meta.url).href;
        const imagePath =  require(`../assets/flag/${imageName}.png`)
        return imagePath;
    } catch(e){
        return mainSnap;
    }
};